<template lang="pug">
.content-wrap
  .content-top
    .con
      section.fullBg(v-if="!startRender")
        .title
          img(src='/new/img/events/valentine/title.png')
        .gift(:class="{'d-flex': !locked || (locked && choice!=''), 'pe-none': (locked && choice!='')}")
          img.g.g1(src='/new/img/events/valentine/g1.png' @click="pickGift('SMOOTHIE')")
          img.g.g2(src='/new/img/events/valentine/g2.png' @click="pickGift('PAU')")
          img.g.g3(src='/new/img/events/valentine/g3.png' @click="pickGift('HOTDOG')")
          img.g.g4(src='/new/img/events/valentine/g4.png' @click="pickGift('COKE')")
          img.g.g5(src='/new/img/events/valentine/g5.png' @click="pickGift('CURRY')")
          img.g.g6(src='/new/img/events/valentine/g6.png' @click="pickGift('COFFEE')")
          img.final(v-if="choice!=''" :src="`/new/img/events/valentine/${gift[choice].src}-final.png`" :class="{'d-flex': choice!='' && !showSelected}")
        .lockImg(v-if="locked && choice==''" @click="checkStatus")
          img(src='/new/img/events/valentine/lock.png')
        .chosePopup(:class="{'d-flex': (!locked && showConfirmation) || (locked && showSelected)}")
          .popupContent.choseOption(v-if="showConfirmation" :class="{'d-none': choice!='' && showSelected && !showConfirmation}")
            img.choseItem(v-if="choice !==''" :src="`/new/img/events/valentine/${gift[choice].src}-choseItem.png`")
            .actionButton
              img.confirm(src='/new/img/events/valentine/confirm.png' @click="confirmSelection")
              img.cancel(src='/new/img/events/valentine/cancel.png' @click="cancelConfirmation")
          .popupContent.confirmed(v-if="showSelected && !showConfirmation" :class="{'d-flex': choice!='' && showSelected && !showConfirmation}")
            img.selected(:src="`/new/img/events/valentine/${gift[choice].src}-selected.png`")
            .actionButton
              img.goback(src='/new/img/events/valentine/goback.png' @click="hideSelected")
        .container
          .content-padding.text-white
            h3 Bonus Terms & Conditions
            p To qualify for this bonus, players must accumulate a minimum deposit of ₱3,000 within 30 days.
            p The final bonus will be credited after the event ends.
            h3 GENERAL TERMS &amp; CONDITIONS
            p Maximum of 5 withdrawals per day.
            p Minimum withdrawal amount: ₱100.
            p EpicWin reserves the right to suspend or terminate accounts that violate the terms and conditions without prior notice.
</template>
<script>
export default{
	data(){
		return{
      startRender: false,
			locked: true,
			showConfirmation: false,
			showSelected:false,
			choice: "",
			gift:{
				"COKE": { src: "g4" },
				"PAU": { src: "g2" },
				"SMOOTHIE": { src: "g1" },
				"HOTDOG": { src: "g3" },
				"CURRY": { src: "g5" },
				"COFFEE": { src: "g6" },
			}
		}
	},
	computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
  },
	watch:{
    sessionToken(newState, oldState){
      if(newState === '' || newState === undefined){
        this.locked = true
				this.choice = ""
      }else{
				this.eventCheck()
      }
    }
  },
  mounted(){
		this.eventCheck()
  },
	methods:{
		checkStatus(){
			if(this.isLoggedIn){
				this.$router.push("/deposit").catch(err => {});
			}else{
				// this.$router.push("/login").catch(err => {});
        this.$helpers.openModal('#logModal')
			}
		},
		pickGift(option){
      this.choice = option
      this.showConfirmation = true
			this.showSelected=true
    },
		cancelConfirmation(){
			this.choice = ""
      this.showConfirmation = false
			this.showSelected=false
		},
    confirmSelection(){
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let icon = this.choice
        this.$store
          .dispatch("user/pickiconCampaign", { account_id, auth_token,  icon})
          .then(response => {
            if (response.success == true) {
							this.showConfirmation = false
              this.showSelected = true
							this.eventCheck()
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }  
          });
      }else{
        $("#modal-login").modal("show")
      }
    },
		eventCheck(){
			if (this.sessionToken) {
        this.startRender = true
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/pickiconcampaignCheck", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              if(response.data.length > 0){
                if(response.data[0].locked == true){
									this.locked = true
									if(response.data[0].icon !== null){
										this.choice = response.data[0].icon
									}else{
										this.choice = ""
									}
								}else{
									this.locked = false
								}
              }else{
								this.locked = true
              }
              this.startRender = false
            } else {
              this.startRender = false
							this.locked = true
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            this.startRender = false
						this.locked = true
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }  
          });
      }
		},
		hideSelected(){
			this.showSelected = false
		}
	}
}
</script>
<style lang="css" scoped>
body {
    margin: 0px;
}

* {
    box-sizing: border-box;
}

.fullBg {
    /* background-image: url('/new/img/events/valentine/bg.jpg'); */
    background-image: url('/new/img/events/valentine/bg.png');
    background-repeat: no-repeat;
    background-position: center top;
    /* background-size: 100% auto; */
    background-size: cover;
    font-family: arial;
    background-color: #c783e6;
    position: relative;
    max-width: 800px;
    margin: auto;
}

.title,
.gift,
.lockImg {
    text-align: center;
}

.title {
    margin-bottom: -5%;
}

.title img {
    max-width: 90%;
    margin: auto;
}

.container {
    position: relative;
    padding: 0 10px;
    margin: 0 auto;
    max-width: 1360px;
}

.content-padding {
    padding-top: 50px;
    padding-bottom: 50px;
}

.gift {
    background-image: url('/new/img/events/valentine/gift.png');
    background-size: 100% 100%;
    /* padding: 20% 10%; */
    padding: 30% 0 0 0;
    display: flex;
    flex-wrap: wrap;
    position: relative;
    display: none;
}

.gift img {
    width: 30%;
    filter: drop-shadow(5px 5px 2px #fff);
    margin: 3.6% 1%;
    cursor: pointer;
}

.gift img.lockImg {
    filter: none;
    width: 100%;
    position: absolute;
    top: 0;
    left: 10%;
    z-index: 9;
}

.lockImg {
    position: relative;
    cursor: pointer;
}

.lockImg img {
    width: 100%;
}

.gift img.final {
    position: absolute;
    top: 0;
    left: 0;
    /* width: 92%; */
    width: 100%;
    filter: none;
    margin: auto;
    right: 0;
    bottom: 0;
    display: none;
    height: 100%;
}

.chosePopup {
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgb(0 0 0 / 70%);
    display: flex;
    width: 100%;
    height: 100%;
    align-items: flex-start;
    justify-content: center;
    z-index: 9;
    display: none;
    padding-top: 60%;
}

.popupContent {
    width: 100%;
    display: flex;
    flex-direction: column;
}

.popupContent img {
    max-width: 90%;
    margin: auto;
}

.actionButton {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 90%;
    margin: auto;
}

.actionButton img {
    width: 50%;
    cursor: pointer;
}

.confirmed {
    display: none;
}


@media (max-width:480px) {
    .fullBg {
        background-size: 100% 100%;
    }
}
/* @media (max-width:767px) {
  .gift{
    padding: 30% 0 0 0;
  }
} */
</style>